import * as React from "react"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

// Steel & Ember — Status badges with semantic discipline.
const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-medium uppercase tracking-[0.08em] transition-colors focus:outline-none focus:ring-2 focus:ring-ember-500/40 focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:     "border-transparent bg-[#1E4E8C] !text-white hover:bg-[#163d70]",
        secondary:   "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        destructive: "border-transparent bg-[#DC2626] !text-white hover:bg-[#B91C1C]",
        outline:     "text-foreground border-border",
        // Semantic status pills (mission-control vocabulary)
        'on-track':  "border-steel-500/30 bg-steel-500/10 text-steel-300 dark:text-steel-200",
        completed:   "border-verdigris-500/30 bg-verdigris-500/12 text-verdigris-500",
        ahead:       "border-verdigris-500/30 bg-verdigris-500/12 text-verdigris-500",
        delayed:     "border-amber-500/30 bg-amber-500/10 text-amber-600 dark:text-amber-400",
        'at-risk':   "border-crimson-500/30 bg-crimson-500/12 text-crimson-500 dark:text-red-400",
        ember:       "border-ember-500/30 bg-ember-500/10 text-ember-500 dark:text-ember-300",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

function Badge({
  className,
  variant,
  ...props
}) {
  return (<div className={cn(badgeVariants({ variant }), className)} {...props} />);
}

export { Badge, badgeVariants }
